import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { IonicModule } from '@ionic/angular';
import { UppercaseDirective } from 'src/app/directives/uppercase.directive';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@Component({
  selector: 'app-input-prefix-field',
  templateUrl: './input-prefix-field.component.html',
  styleUrls: ['./input-prefix-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputPrefixFieldComponent),
      multi: true
    },
        provideNgxMask()

  ],
  standalone: true,
  imports: [UppercaseDirective, NzInputModule, NgxMaskDirective, NzIconModule, IonicModule, CommonModule, FormsModule, TranslocoDirective],
})
export class InputPrefixFieldComponent {

  @ViewChild('myInput', { static: false }) myInput!: ElementRef;

  passwordVisible = false
  @Output() valueChange = new EventEmitter<any>();
  @Input() placeholder: string = '';
  @Input() title: string = '';
  @Input() prefix: string = '';
  @Input() thousandSeparator: string = ''
  @Input() type: string = 'text'
  @Input() suffix: string = ''
  @Input() text_align: string = 'left'
  @Input() disabled = false
  @Input() isCapitalRequired = false
  @Input() dropSpecialCharacters = false
  @Input() maxLenght = null
   @Input() mask = ''


  @Input() showForgotPassword: boolean = false;
  @Input() validator: object = {
    status: ''
  }; // Default is 'error'

  value: any = '';

  // Handle input change

  onInput(event: any) {
    this.validator = {}
    this.value = event.target.value;
    this.onChange(this.value);
    this.valueChange.emit(this.value);
  }

  // Write value to model
  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  // Register onChange method
  onChange: (value: any) => void = () => { };

  // Register onTouched method
  onTouched: () => void = () => { };

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  moveCursorToEnd() {
    const inputEl = this.myInput.nativeElement;

    const length = inputEl.value.length;
    console.log(length)
    inputEl.setSelectionRange(length - 1, length);

  }

  enforceMaxLength(event: any) {
    if (this.maxLenght !== null && event.target.value.length > this.maxLenght) {
      event.target.value = event.target.value.slice(0, this.maxLenght);
    }
  }

}
